import { CandlestickSeries, LineSeries, AreaSeries, BarSeries } from 'lightweight-charts';

export const CHART_LAYOUT = {
  background: { color: '#161a1e' },
  textColor: '#a0a0a0',
};

export const CHART_GRID = {
  vertLines: { color: '#242730' },
  horzLines: { color: '#242730' },
};

export const CHART_PRICE_SCALE = {
  borderColor: '#242730',
  autoScale: true,
};

export const CHART_TIME_SCALE = {
  borderColor: '#242730',
  timeVisible: true,
  secondsVisible: false,
  rightOffset: 12,
  barSpacing: 12,
  fixLeftEdge: false,
};

export const SERIES_CONFIG = {
  Candlestick: { constructor: CandlestickSeries, options: {
    upColor: '#0ecb81', downColor: '#f6465d',
    borderUpColor: '#0ecb81', borderDownColor: '#f6465d',
    wickUpColor: '#0ecb81', wickDownColor: '#f6465d',
  }},
  Line: { constructor: LineSeries, options: {
    color: '#2962FF', lineWidth: 2, lastValueVisible: true, priceLineVisible: false,
  }},
  Area: { constructor: AreaSeries, options: {
    topColor: 'rgba(41, 98, 255, 0.4)', bottomColor: 'rgba(41, 98, 255, 0.02)',
    lineColor: '#2962FF', lineWidth: 2, lastValueVisible: true, priceLineVisible: false,
  }},
  Bar: { constructor: BarSeries, options: {
    upColor: '#0ecb81', downColor: '#f6465d',
    thinUpBars: true,
  }},
};

export const VOLUME_SERIES_OPTIONS = {
  priceFormat: { type: 'volume' },
  priceScaleId: 'volume',
};

export const createChartOptions = (width) => ({
  layout: CHART_LAYOUT,
  grid: CHART_GRID,
  crosshair: { mode: 0 },
  rightPriceScale: CHART_PRICE_SCALE,
  timeScale: CHART_TIME_SCALE,
  width: width || 800,
  height: 450,
  watermark: {
    visible: false,
  },
});

export const formatKline = (d) => ({
  time: d[0] / 1000,
  open: parseFloat(d[1]),
  high: parseFloat(d[2]),
  low: parseFloat(d[3]),
  close: parseFloat(d[4]),
  volume: parseFloat(d[5]),
});

export const formatLiveCandle = (k) => ({
  time: k.t / 1000,
  open: parseFloat(k.o),
  high: parseFloat(k.h),
  low: parseFloat(k.l),
  close: parseFloat(k.c),
  volume: parseFloat(k.v),
});
